import axios from 'axios';
import { API_BASE_URL } from '../config';

const PENDING_COUPON_KEY = 'pendingCouponCode';

/** UI-only formatters (no business rules). */
export function formatCouponDiscount(coupon) {
    if (!coupon) return '';
    return coupon.type === 'percentage' ? `${coupon.discount}% OFF` : `₹${coupon.discount} OFF`;
}

export function formatCouponMinOrder(minOrder) {
    return `Min. order ₹${Number(minOrder).toLocaleString('en-IN')}`;
}

export function setPendingCouponCode(code) {
    try {
        if (code) {
            sessionStorage.setItem(PENDING_COUPON_KEY, String(code).trim().toUpperCase());
        } else {
            sessionStorage.removeItem(PENDING_COUPON_KEY);
        }
    } catch (_e) {
        /* private mode */
    }
}

export function consumePendingCouponCode() {
    try {
        const code = sessionStorage.getItem(PENDING_COUPON_KEY);
        sessionStorage.removeItem(PENDING_COUPON_KEY);
        return code || null;
    } catch (_e) {
        return null;
    }
}

/** GET /coupons — catalog from backend. */
export async function fetchCoupons({ activeOnly = false } = {}) {
    const params = activeOnly ? { activeOnly: 'true' } : {};
    const { data } = await axios.get(`${API_BASE_URL}/coupons`, { params });
    if (!data?.success) {
        throw new Error(data?.message || 'Failed to load coupons');
    }
    return data.coupons || [];
}

/** GET /coupons/:code — resolve a single coupon (optional orderAmount for applicability). */
export async function fetchCouponByCode(code, orderAmount = 0) {
    const normalized = String(code || '').trim();
    if (!normalized) return null;

    const { data } = await axios.get(
        `${API_BASE_URL}/coupons/${encodeURIComponent(normalized)}`,
        { params: orderAmount > 0 ? { orderAmount } : {} }
    );

    if (!data?.success) return null;
    return data.coupon || null;
}

/** Apply pending code from Coupons page → Cart. */
export async function resolvePendingCoupon(coupons) {
    const pending = consumePendingCouponCode();
    if (!pending) return null;
    const fromList = coupons.find((c) => c.code.toUpperCase() === pending.toUpperCase() && !c.expired);
    if (fromList) return fromList;
    try {
        return await fetchCouponByCode(pending);
    } catch (_e) {
        return null;
    }
}
